function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, JSON, Object, keydownProxyEl, searchFilter) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": {
          'mp-breakdown-menu': true
        },
      }, (function() {
        var __jade_nodes = [];
        const selectedEvent = $helpers.getSelectedEvent();;
        __jade_nodes = __jade_nodes.concat((selectedEvent) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-properties-menu", {
            "attrs": __vjadeStringifyAttrsIfObj({
              'open': $attr(`open`),
              'search-filter': searchFilter,
              'include-custom-properties': $attr(`include-custom-properties`),
              'event-names': JSON.stringify([selectedEvent.value]),
              'selected': JSON.stringify($helpers.getSelectedProperty()),
              'project-id': $attr(`project-id`),
              'workspace-id': $attr(`workspace-id`),
              'track-name': $attr(`track-name`),
              'show-special-date-property': true,
            }),
            "hook": {
              insert: $helpers.onMenuInserted
            },
            "props": {
              context: `breakdown`,
              keydownProxyEl,
              tooltipPositionParentElement: $component.tooltipPositionParentElement,
            },
            "on": {
              select: $helpers.handleSelectProperty,
              stagedproperty: $helpers.handleStagedProperty,
              tooltipContextEditDescription: $helpers.propagateEvent,
            },
          }));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-events-menu", {
            "attrs": __vjadeStringifyAttrsIfObj({
              'open': $attr(`open`),
              'search-filter': searchFilter,
              'data-group-id': $attr(`data-group-id`),
              'project-id': $attr(`project-id`),
              'workspace-id': $attr(`workspace-id`),
            }),
            "hook": {
              insert: $helpers.onMenuInserted
            },
            "props": {
              context: `breakdown`,
              keydownProxyEl,
              tooltipPositionParentElement: $component.tooltipPositionParentElement,
            },
            "on": {
              select: $helpers.handleSelectEvent,
              tooltipContextAction: $helpers.propagateEvent,
              tooltipContextEditDescription: $helpers.propagateEvent,
            },
          }));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "keydownProxyEl" in locals ? locals.keydownProxyEl : typeof keydownProxyEl !== "undefined" ? keydownProxyEl : undefined, "searchFilter" in locals ? locals.searchFilter : typeof searchFilter !== "undefined" ? searchFilter : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;